'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unloadMediaQueryService = exports.loadMediaQueryService = undefined;

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _ToggleMobileLayoutAction = require('../components/ui/actions/ToggleMobileLayoutAction');

var _ToggleMobileLayoutAction2 = _interopRequireDefault(_ToggleMobileLayoutAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediaQuery = void 0;

var listener = function listener(mq) {
  (0, _Store2.default)().dispatch((0, _ToggleMobileLayoutAction2.default)(!mq.matches));
};

var loadMediaQueryService = exports.loadMediaQueryService = function loadMediaQueryService() {
  mediaQuery = window.matchMedia('(min-width: 768px)'); // mobile/desktop breakpoint

  mediaQuery.addListener(listener); // add listener for dispatching when breakpoint is hit

  listener(mediaQuery); // run once to intialize with current breakpoint
};

var unloadMediaQueryService = exports.unloadMediaQueryService = function unloadMediaQueryService() {
  if (!mediaQuery) {
    return;
  }

  mediaQuery.removeListener(listener);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/MediaQueryService.js
// module id = 364
// module chunks = 10